<template>
  <el-container class="main-content">
    <el-aside width="312px" style="text-align: left; background-color: #2e2e2e; color: #fff;">
      <div class="title-box">
        <el-row>
          <el-col :span="5">
            <user-avatar :src="headImage" className="useravatar-cicle-m"></user-avatar>
          </el-col>
          <el-col :span="19">
            <div>{{hrName}} <img v-if="isVip" :src="require('~/assets/images/crown.png')"
                style="width:20px;vertical-align:text-bottom" /></div>
            <div>{{companyName}}</div>
          </el-col>
        </el-row>
      </div>
      <div>
        <ul class="chat-list">
          <li v-for="(chat, index) in chatUserList" :key="index" class="msg-item"
            :class="chat.actived ? 'active-msg-item': ''" @click="chatWith(chat)">
            <el-row :gutter="16">
              <el-col :span="5" class="left">
                <user-avatar :src="chat.HeadImage" className="useravatar-cicle-m"></user-avatar>
              </el-col>
              <el-col :span="19" class="right">
                <el-row>
                  <el-col :span="17" class="who-name">{{chat.ContactName}}
                    <span>[{{roleName(chat.ContactUserRole)}}]</span></el-col>
                  <el-col :span="7" class="time">{{$Shared.getChatTime(chat.LastChatTime)}}
                  </el-col>
                </el-row>
                <el-row style="margin-top: 6px;">
                  <el-col :span="20" class="last-msg" v-html="$Shared.removeHref(chat.LastChatContent)"></el-col>
                  <el-col :span="4" class="text-right">
                    <el-badge class="chat-unread" :value="chat.UnreadNum" v-if="chat.UnreadNum" />
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </li>
        </ul>
      </div>
    </el-aside>
    <el-main class="right-panel">
      <div class="chat-container">
        <header>
          <div class="chat-header">{{activedChat.ContactName}} <span>[{{roleName(activedChat.ContactUserRole)}}<span
                v-if="notLookJob">（暂时不找工作）</span>]</span>
          </div>
        </header>
        <el-row>
          <el-col :span="17" class="chat-content-box">
            <div class="reply-box" id="replybox">
              <ul>
                <li class="text-center text-more" v-if="loading">
                  <span>正在加载中...</span>
                </li>
                <li class="text-center text-more" v-else>
                  <span v-if="finished">没有聊天记录了</span>
                  <a v-else @click="getMessages">查看更多消息</a>
                </li>
                <li v-for="(item, index) in messages" :key="index">
                  <p class="text-center">
                    <span class="sys-chat-text">{{ formatTime(item.send_time) }}</span>
                  </p>
                  <div class="text-center" v-if="item.type >= 3 && item.type != 15 && item.type != 17">
                    <router-link v-if="item.type === 3" :to="{name:'JobDetail', query: {id: item.job.jobId}}"
                      target="_blank">
                      <p class="sys-chat-text">您更换了和该人才沟通的职位</p>
                      <div class="msg-sp-item">
                        <p class="msg-title">{{item.job.jobName}}</p>
                        <p>{{item.job.cityName}}<span class="msg-split">|</span>{{item.job.postSalary}}</p>
                        <p>发布时间：{{$Shared.formatDate(item.job.refreshDate)}}</p>
                      </div>
                    </router-link>
                    <router-link v-else-if="item.type === 16" :to="{name:'JobDetail', query: {id: item.job.jobId}}">
                      <div class="msg-sp-item">
                        <p class="msg-title">{{item.job.jobName}}</p>
                        <p>{{item.job.cityName}}<span class="msg-split">|</span>{{item.job.postSalary}}</p>
                        <p>发布时间：{{$Shared.formatDate(item.job.refreshDate)}}</p>
                      </div>
                    </router-link>
                    <p class="sys-chat-text" v-else-if="item.type === 4">对人才发送了面试邀请</p>
                    <p class="sys-chat-text" v-else-if="item.type === 5">人才接受了面试邀请</p>
                    <p class="sys-chat-text" v-else-if="item.type === 6">人才拒绝了面试邀请</p>
                    <p class="sys-chat-text" v-else-if="item.type === 7">请求交换手机号码，等待人才同意</p>
                    <p class="sys-chat-text" v-else-if="item.type === 8">接受了交换手机号，人才的号码：{{toUserInfo.toUserMobile}}</p>
                    <p class="sys-chat-text" v-else-if="item.type === 9">拒绝了对方交换手机号</p>
                    <div v-else-if="item.type === 10">
                      <p class="sys-chat-text">请求交换手机号码</p>
                      <div class="relative-dialog" v-if="item.handled !== 1">
                        <div class="el-dialog__header">人才请求交换手机号码</div>
                        <div class="el-dialog__content">是否同意？</div>
                        <div class="el-dialog__footer">
                          <button class="el-button el-button--default" @click="refuseExchangeMobile(item.chat_id)">
                            <span>拒绝</span>
                          </button>
                          <button class="el-button el-button--primary" @click="applyExchangeMobile(item.chat_id)">
                            <span>同意</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <p class="sys-chat-text" v-else>{{item.content}}</p>
                  </div>
                  <div :class="(item.from_user_id == fromUserId && item.from_user_role == fromUserRole) ? 'my' : 'user'"
                    v-if="item.type < 3 || item.type == 15 || item.type == 17">
                    <user-avatar
                      :src="(item.from_user_id == fromUserId && item.from_user_role == fromUserRole) ? headImage : toUserHeadImage"
                      className="useravatar"></user-avatar>
                    <div v-if="item.type == 15" class="chat-resume-container">
                      <router-link v-if="item.recommendMe" :to="'/TalentDetail?id='+item.recommendMe.me_id+'&type=1'"
                        target="_blank">
                        <div class="msg-sp-item">
                          <el-col :span="5">
                            <user-avatar :src="item.recommendMe.head_image" className="recommend-me-useravatar">
                            </user-avatar>
                          </el-col>
                          <el-col :span="19" class="recommend_me_text">
                            <p class="msg-title">{{item.recommendMe.me_name}}</p>
                            <el-row>
                              <span v-if="item.recommendMe.live_city">{{item.recommendMe.live_city}}<i
                                  class='msg-split'>|</i></span>
                              <span v-if="item.recommendMe.work_exp">{{item.recommendMe.work_exp}}经验<i
                                  class='msg-split'>|</i></span>
                              <span v-if="item.recommendMe.degree_name">{{item.recommendMe.degree_name}}<i
                                  class='msg-split'>|</i></span>
                              <span v-if="item.recommendMe.salary">{{item.recommendMe.salary}}</span>
                            </el-row>
                            <el-row v-if="item.recommendMe.work_company_name">
                              {{item.recommendMe.work_company_name}}<i
                                class="msg-split">·</i>{{item.recommendMe.work_position_name}}</el-row>
                            <el-row v-if="item.recommendMe.work_company_name">
                              {{formatDate(item.recommendMe.work_start_date)}}<i
                                class='msg-split'>-</i>{{formatDate2(item.recommendMe.work_end_date)}}
                            </el-row>
                          </el-col>
                        </div>
                      </router-link>
                    </div>
                    <div v-else class="detail">
                      <div v-if="item.type === 2" class="msg-img" v-html="$Shared.buildImageContent(item.content)"
                        @click="showImage(item.content)"></div>
                      <div v-else-if="item.type === 17" class="message" v-html="item.content"></div>
                      <div v-else class="message" v-html="item.content"></div>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-if="isOffline" class="chat-alert-wrapper">
                <el-alert title="您已在其他页面发起咨询，当前咨询已失效" type="error">
                </el-alert>
              </div>
            </div>
            <div class="mesbox">
              <tinymce ref='tinymce' :height="97" v-model="message" :toolbar="toolbar" :toUserRole="toUserRole"
                @sendmessage="sendOutMessage"></tinymce>
              <div style="margin: 4px; padding-right: 10px; color: #999999; font-size:12px; text-align:right">
                <span>支持微信截图、QQ截图、复制图片粘贴到发送框</span></div>
              <div class="chat-footer">
                <el-button type="primary" size="small" class="chat-confirm" :disabled="notLookJob || isOffline"
                  @click="sendOutMessage">发 送
                </el-button>
              </div>
            </div>
          </el-col>
          <el-col :span="7" class="chat-tabs">
            <el-tabs type="card" v-model="activeName">
              <el-tab-pane v-if="toUserRole === 1" label="操作助手" name="assistant">
                <div class="chat-tools-box">
                  <div>
                    <el-button size="mini" @click="isContact ? exChangeMobile() : noConactAlert()"
                      :disabled="isOffline">手机号</el-button>
                    <el-button size="mini" @click="isContact ? inviteInterview() : noConactAlert()"
                      :disabled="isOffline">约面试</el-button>
                    <el-button size="mini" @click="changeJob" :disabled="isOffline">换职位</el-button>
                  </div>
                  <transition :css="jobTransEnable" name="bounce">
                    <div v-if="selectJobShow">
                      <div style="margin-top: 12px;">
                        请选择要发送的职位：
                      </div>
                      <JobSelectList @changeSelect="onSelectJob"></JobSelectList>
                      <el-button size="mini" style="margin-top: 12px;" @click="onCloseSelectJob">取消</el-button>
                    </div>
                  </transition>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="toUserRole === 1" label="求职者信息" name="info">
                <div class="chat-tools-box">
                  <ChatBasicResume :userId="toUserId"></ChatBasicResume>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </div>
    </el-main>
    <el-dialog append-to-body custom-class="preview-image" :visible.sync="chatImgVisible">
      <img class="js-preview-image" :src="chatImg" />
    </el-dialog>
    <el-dialog title="邀约面试信息" append-to-body :visible.sync="inviteShow">
      <el-form ref="inviteForm" :model="inviteForm" label-width="80px">
        <el-form-item label="职位" required>
          <el-input v-model="job.jobName" disabled></el-input>
        </el-form-item>
        <el-form-item label="联系电话" required>
          <el-input v-model="inviteForm.interviewPhone" :disabled="notInviteAgain"></el-input>
        </el-form-item>
        <el-form-item label="面试地点" required>
          <el-input v-model="inviteForm.interviewPlace" :disabled="notInviteAgain"></el-input>
        </el-form-item>
        <el-form-item label="面试时间" required>
          <el-date-picker v-model="inviteForm.interviewTime" :disabled="notInviteAgain" type="datetime"
            placeholder="选择日期时间" default-time="10:00:00">
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="inviteForm.inviteId > 0 && inviteForm.meVote != 2">
          <el-button v-if="inviteForm.meVote == 0 && !inviteForm.expired">已发送邀请</el-button>
          <el-button v-if="inviteForm.meVote == 0 && inviteForm.expired" @click="inviteAgain()">邀约已过期，重新邀约</el-button>
          <el-button v-if="inviteForm.meVote == 1" @click="toInterview()">人才已接受</el-button>
          <el-button @click="inviteShow = false">关闭</el-button>
        </el-form-item>
        <el-form-item v-else>
          <el-button type="primary" :disabled="isOffline" @click="onConfirmInvite('inviteForm')">确定</el-button>
          <el-button @click="inviteShow = false">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-container>
</template>

<script>
  import Vue from 'vue';
  import Velocity from 'velocity-animate';
  import {
    initWs,
    send
  } from '~/service/ws';
  import {
    getJobSimpleInfo
  } from '~/api/job';
  import {
    getLastUserList,
    getChatList,
    sendMessage,
    readOneChat,
    meSimpleInfo,
    readChat,
    isContact,
    isExchangedMobile,
    chatUserInfo,
    getJobId,
    defaultInviteInfo
  } from '~/api/chat';
  import {
    getMyHrService,
    getUserInfoChat
  } from '~/api/user';
  import UserAvatar from '~/components/UserAvatar';
  import UserAvatarSmall from '~/components/UserAvatarSmall';
  import tinymce from '~/components/Tinymce/emojiindex';
  import JobSelectList from '~/components/JobSelectList';
  import ChatBasicResume from '~/components/ChatBasicResume';
  export default {
    components: {
      UserAvatar,
      UserAvatarSmall,
      tinymce,
      JobSelectList,
      ChatBasicResume
    },
    data() {
      return {
        ws: null,
        userId: 0,
        companyName: '',
        isVip: false,
        coPostId: 0,
        chatUserList: [],
        fromUserRole: 2,
        activedChat: {},
        messages: [],
        loading: false,
        finished: false,
        pageIndex: 1,
        chatImgVisible: false,
        chatImg: '',
        toolbar: ['emoticons'],
        message: '',
        activeName: 'assistant',
        notLookJob: false,
        toUserInfo: {
          toUserName: '',
          toUserHeadImage: '',
          toUserMobile: '',
          toUserEmail: '',
          companyName: '',
          meState: 0,
          recState: 0,
        },
        jobId: 0,
        selectJobShow: false,
        isContact: false,
        job: {},
        inviteShow: false,
        inviteForm: {
          inviteId: 0,
          interviewId: 0,
          interviewPhone: '',
          interviewPlace: '',
          interviewTime: '',
          meVote: 0,
          expired: false,
        },
        isOffline: false,
        fromUserId: this.$store.state.user.userId,
        headImage: this.$store.state.user.headImage,
        hrName: this.$store.state.user.hrName,
        jobTransEnable: false,
      };
    },
    computed: {
      toUserId() {
        if (this.activedChat && this.activedChat.ContactUserDataID) {
          return this.activedChat.ContactUserDataID;
        } else {
          return 0;
        }
      },
      toUserRole() {
        if (this.activedChat && this.activedChat.ContactUserRole) {
          return this.activedChat.ContactUserRole;
        } else {
          return 0;
        }
      },
      toUserHeadImage() {
        if (this.activedChat && this.activedChat.HeadImage) {
          return this.activedChat.HeadImage;
        } else {
          return 0;
        }
      },
      notInviteAgain() {
        if (this.inviteForm.inviteId > 0 && this.inviteForm.meVote !== 2) {
          return true;
        }
        return false;
      },
    },
    created() {
      this.$emit('changeMenu', 'HrChat');
      if (this.$route.query && this.$route.query.userid) {
        this.userId = parseInt(this.$route.query.userid);
      }
      this.getMyInfo();
      this.getLastContactUserList();
      if (this.$route.query.jobid) {
        this.jobId = parseInt(this.$route.query.jobid);
      }

      this.ws = initWs();
      let that = this;
      this.ws.onmessage = function (e) {
        that.onMessage(e);
      };
      this.ws.onerror = function (e) {
        that.onSendError(e);
      };
    },
    methods: {
      getMyInfo() {
        getMyHrService().then(m => {
          if (m.errcode == 0) {
            let data = m.data;
            if (data) {
              this.companyName = data.company_name;
              this.isVip = data.is_vip;
            }
          }
        });
      },
      getLastContactUserList() {
        getLastUserList()
          .then(m => {
            if (m.errcode == 0) {
              var list = m.data;
              if (list) {
                var me = list.findIndex(x => (x.ContactUserDataID == this.fromUserId && x
                  .ContactUserRole ==
                  this.fromUserRole));
                if (me >= 0) {
                  list.splice(me, 1);
                }
                this.chatUserList = list;
                this.addNewChatUser().then(() => {
                  var firstChat = this.chatUserList[0];
                  if (firstChat) {
                    this.chatWith(firstChat);
                  }
                });
              }
            }
          });
      },
      addNewChatUser() {
        return new Promise((resolve, reject) => {
          if (this.userId) {
            var userInfoIndex = this.chatUserList.findIndex(x => (x.ContactUserDataID == this.userId && x
              .ContactUserRole == 1));
            if (userInfoIndex >= 0) {
              var userInfo = this.chatUserList[userInfoIndex];
              this.chatUserList.splice(userInfoIndex, 1);
              this.chatUserList.unshift(userInfo);
              resolve();
            } else {
              var params = {
                userDataId: this.userId,
                role: 1,
              };
              chatUserInfo(params).then(r => {
                if (r.errcode === 0) {
                  var data = r.data;
                  if (data) {
                    var chatUser = {
                      ContactName: data.ContactName,
                      ContactUserDataID: data.ContactUserDataID,
                      ContactUserRole: data.ContactUserRole,
                      HeadImage: data.HeadImage,
                      LastChatContent: '',
                      LastChatID: 0,
                      LastChatTime: '1900-1-1',
                      LastChatType: 0,
                      Level: null,
                      Mobile: '',
                      OnlineState: false,
                      OrgName: '',
                      UnreadNum: data.UnreadNum,
                      actived: false
                    };
                    this.chatUserList.unshift(chatUser);
                    resolve();
                  }
                }
              });
            }
          } else {
            resolve();
          }
        });
      },
      roleName(roleId) {
        switch (roleId) {
        case 1:
          return '会员';
        case 2:
          return '人事';
        case 3:
          return '顾问';
        }
      },
      chatWith(chat) {
        this.activedChat = chat;
        this.getToUserInfo();

        this.messages = [];
        this.pageIndex = 1;
        this.getMessages();

        this.chatUserList.forEach(u => u.actived = false);
        chat.actived = true;
        chat.UnreadNum = 0;
        var clickIndex = this.chatUserList.findIndex(u => u.LastChatID == chat.LastChatID);
        Vue.set(this.chatUserList, clickIndex, chat);

        this.getJobInfo();
        this.getIsContact();
        if (chat.job_id > 0) {
          this.jobId = chat.job_id;
        }
        this.message = '';
        if (tinyMCE && tinyMCE.activeEditor) {
          tinyMCE.activeEditor.setContent('');
        }
      },
      getMessages() {
        this.loading = true;
        var params = {
          'to_user_id': this.toUserId,
          'to_user_role': this.toUserRole,
          'page_index': this.pageIndex
        };
        getChatList(params).then(m => {
          if (m.errcode == 0) {
            let datas = m.data.list;
            datas.forEach(msg => {
              msg.job = {};
              msg.recommendMe = {};
              if (msg.type === 3 || msg.type === 16) {
                this.jobId = msg.job_id;
                getJobSimpleInfo({
                  job_id: this.jobId,
                }).then(m => {
                  if (m.errcode == 0) {
                    let job = m.data;
                    msg.job = job;
                  }
                });
              } else if (msg.type === 15) {
                var meDataId = msg.me_data_id;
                meSimpleInfo({
                  meDataId: meDataId
                }).then(m => {
                  if (m.errcode === 0) {
                    msg.recommendMe = m.data;
                  }
                });
              }
              this.messages.unshift(msg);
            });
            this.loading = false;
            this.pageIndex = this.pageIndex + 1;
            let isNext = m.data.has_next_page;
            this.finished = !isNext;
            this.readAllMessage();
            this.$nextTick(() => {
              this.scrollEnd();
            });
          } else {
            this.$message(m.errmsg);
            this.loading = false;
          }
        })
          .catch(error => {
            this.$message('获取消息失败，错误信息' + error);
            this.loading = false;
          });
      },
      readAllMessage() {
        readChat({
          'from_user_id': this.toUserId,
          'from_user_role': this.toUserRole,
        }).then();
      },

      onMessage(event) {
        let msg = JSON.parse(event.data);
        let textMsg;
        if (msg) {
          textMsg = msg.data;
        }
        if (msg.type == 1) { //下线通知
          var offUserId = msg.data;
          if (offUserId == this.fromUserId) {
            this.isOffline = true;
          }
        }
        if (textMsg && textMsg.content) {
          if (textMsg.from_user_id == this.toUserId && textMsg.from_user_role == this.toUserRole) {
            var msgObj = {
              chat_id: textMsg.chat_id,
              type: textMsg.type,
              content: textMsg.content,
              from_user_id: textMsg.from_user_id,
              send_time: textMsg.send_time,
              to_user_id: textMsg.to_user_id
            };
            msgObj.job = {};
            msgObj.recommendMe = {};
            if (textMsg.type === 3 || textMsg.type === 16) {
              var jobId = textMsg.job_id;
              getJobSimpleInfo({
                job_id: jobId,
              }).then(m => {
                if (m.errcode == 0) {
                  msgObj.job = m.data;
                }
              });
            } else if (textMsg.type === 15) {
              var meDataId = textMsg.me_data_id;
              meSimpleInfo({
                meDataId: meDataId
              }).then(m => {
                if (m.errcode === 0) {
                  msgObj.recommendMe = m.data;
                }
              });
            }
            this.messages.push(msgObj);
            setTimeout(this.getIsContact, 100);
            this.readOneMessage(textMsg.chat_id);
          } else {
            var userInfoIndex = this.chatUserList.findIndex(x => (x.ContactUserDataID == textMsg.from_user_id && x
              .ContactUserRole == textMsg.from_user_role));
            if (userInfoIndex >= 0) {
              var userInfo = this.chatUserList[userInfoIndex];
              userInfo.UnreadNum++;
            }
          }
        }
        this.$nextTick(() => {
          this.scrollEnd();
        });
      },
      onSendError(event) {
        this.$message({
          type: 'error',
          duration: 3000,
          showClose: true,
          message: '聊天服务器未连接，消息将以离线消息的形式发送'
        });
        if (event && event.data) {
          sendMessage(event).then(m => {
            if (m.errcode !== 0) {
              this.$message({
                type: 'error',
                duration: 3000,
                showClose: true,
                message: '上条消息发送失败，请刷新页面后重试'
              });
              // this.$message.error('上条消息发送失败，请刷新页面后重试');
            }
          });
        }
      },
      readOneMessage(chatID) {
        readOneChat({
          'chat_id': chatID,
          'to_user_id': this.toUserId,
          'to_user_role': this.toUserRole,
        }).then();
      },
      scrollEnd() {
        var ele = document.getElementById('replybox');
        ele.scrollTop = ele.scrollHeight;
      },
      getIsContact() {
        var params = {
          to_user_id: this.toUserId,
          to_user_role: this.toUserRole
        };
        isContact(params).then(m => {
          if (m.errcode === 0) {
            this.isContact = m.data;
          }
        });
      },
      formatTime(dateTime) {
        return this.$Shared.formatDateTime2(dateTime);
      },
      showImage(imgUrl) {
        this.chatImg = imgUrl;
        this.chatImgVisible = true;
      },
      sendOutMessage(imgUrl, fileName) {
        var doc = new DOMParser().parseFromString(this.message, 'text/xml');
        var firstNode = doc.firstChild;
        if (firstNode.nodeName == 'img') {
          let imgSrc = firstNode.getAttribute('src');
          if (imgSrc.indexOf('data:image') >= 0) {
            let blob = this.dataURItoBlob(imgSrc);
            var formData = new FormData();
            formData.append('image.jpg', blob);
            let config = {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            };

            // 发送请求;
            // eslint-disable-next-line no-undef
            axios.post(this.uploadURL, formData, config).then(res => {
              if (res.data.errcode === 0) {
                imgUrl = res.data.data;
                this.sendMessage(imgUrl);
              } else {
                this.$message.error('图片上传失败，请重试');
              }
            });
          } else {
            this.sendMessage(imgSrc);
          }
        } else {
          this.sendMessage(imgUrl, fileName);
        }
      },
      sendMessage(imgUrl) {
        if (this.jobId <= 0) {
          this.$message('请选择一个职位');
          this.jobTransEnable = true;
          this.selectJobShow = true;
          return false;
        }

        var msgObj;
        if (imgUrl && this.$Shared.isImage(imgUrl)) {
          msgObj = {
            chat_id: 0,
            type: 2, //图片的type为2
            content: imgUrl,
            from_user_id: this.fromUserId,
            from_user_role: this.fromUserRole,
            to_user_id: this.toUserId,
            to_user_role: this.toUserRole,
            send_scene: this.sendScene
          };
        } else {
          var cleanMsg = this.message;
          if (cleanMsg == '') {
            this.$message.error('不能发送空消息！');
            return false;
          }
          if (cleanMsg.length > 1000) {
            this.$message.error('消息内容不能超过1000个字符！');
            return false;
          }
          if (this.toUserRole == 1 && this.$Shared.hasMobile(cleanMsg)) {
            this.$message('消息中不能发送手机号码，请用“交换手机”功能');
            return false;
          }
          msgObj = {
            chat_id: 0,
            type: 1, //普通文本
            content: cleanMsg,
            from_user_id: this.fromUserId,
            from_user_role: this.fromUserRole,
            to_user_id: this.toUserId,
            to_user_role: this.toUserRole,
            job_id: this.jobId,
          };
        }
        let strMsg = {
          'type': 2,
          'data': msgObj
        };
        let msg = JSON.stringify(strMsg);
        let that = this;
        send(msg, function () {
          that.onSendError(strMsg);
        });
        this.messages.push(msgObj);
        this.message = '';
        tinyMCE.activeEditor.setContent('');
        setTimeout(this.getIsContact, 100);
        this.$nextTick(() => {
          this.scrollEnd();
        });
      },
      dataURItoBlob(dataURI, type) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
          type: type
        });
      },
      formatDate2(datetime) {
        if (new Date(datetime).getTime() > new Date('1900-01').getTime()) {
          return this.$Shared.formatDateYearMonth(datetime);
        }
        return '至今';
      },
      formatDate(datetime) {
        if (new Date(datetime).getTime() > new Date('1900-01').getTime()) {
          return this.$Shared.formatDateYearMonth(datetime);
        }
        return '';
      },
      exChangeMobile() {
        var params = {
          to_user_id: this.toUserId,
          to_user_role: this.toUserRole
        };
        isExchangedMobile(params).then(m => {
          if (m.errcode === 0) {
            var exchanged = m.data;
            if (exchanged) {
              var msgExchanged = {
                chat_id: 0,
                type: 8,
                content: '同意交换手机',
                from_user_id: this.toUserId,
                from_user_role: this.toUserRole,
                to_user_id: this.fromUserId,
                to_user_role: this.fromUserRole,
                job_id: this.jobId,
              };
              this.messages.push(msgExchanged);
            } else {
              var msgObj = {
                chat_id: 0,
                type: 7,
                content: '请求交换手机号码',
                from_user_id: this.fromUserId,
                from_user_role: this.fromUserRole,
                to_user_id: this.toUserId,
                to_user_role: this.toUserRole,
                job_id: this.jobId,
              };
              let strMsg = {
                'type': 2, //文本类型消息
                'data': msgObj
              };
              let msg = JSON.stringify(strMsg);
              let that = this;
              send(msg, function () {
                that.onSendError(strMsg);
              });
              this.messages.push(msgObj);
            }
            this.$nextTick(() => {
              this.scrollEnd();
            });
          }
        });
      },
      refuseExchangeMobile(chatId) {
        var msgObj = {
          chat_id: chatId,
          type: 9,
          content: '拒绝交换手机',
          from_user_id: this.fromUserId,
          from_user_role: this.fromUserRole,
          to_user_id: this.toUserId,
          to_user_role: this.toUserRole,
          job_id: this.jobId,
        };
        let strMsg = {
          'type': 2, //文本类型消息
          'data': msgObj
        };
        let msg = JSON.stringify(strMsg);
        let that = this;
        send(msg, function () {
          that.onSendError(strMsg);
        });
        var handleMsg = this.messages.find(msg => msg.chat_id === chatId);
        if (handleMsg) {
          handleMsg.handled = 1;
        }
        this.messages.push(msgObj);
        this.$nextTick(() => {
          this.scrollEnd();
        });
      },
      applyExchangeMobile(chatId) {
        var msgObj = {
          chat_id: chatId,
          type: 8,
          content: '同意交换手机',
          from_user_id: this.fromUserId,
          from_user_role: this.fromUserRole,
          to_user_id: this.toUserId,
          to_user_role: this.toUserRole,
          job_id: this.jobId,
        };
        let strMsg = {
          'type': 2, //文本类型消息
          'data': msgObj
        };
        let msg = JSON.stringify(strMsg);
        let that = this;
        send(msg, function () {
          that.onSendError(strMsg);
        });
        var handleMsg = this.messages.find(msg => msg.chat_id === chatId);
        if (handleMsg) {
          handleMsg.handled = 1;
        }
        this.messages.push(msgObj);
        this.$nextTick(() => {
          this.scrollEnd();
        });
      },
      getToUserInfo() {
        getUserInfoChat({
          'user_data_id': this.toUserId,
          'user_role': this.toUserRole
        }).then(m => {
          if (m.errcode == 0) {
            let toUser = m.data;
            if (toUser) {
              this.toUserInfo.toUserName = toUser.name;
              this.toUserInfo.toUserHeadImage = toUser.head_image;
              this.toUserInfo.toUserMobile = toUser.mobile;
              this.toUserInfo.toUserEmail = toUser.email;
              this.toUserInfo.companyName = toUser.company_name;
              this.toUserInfo.meState = toUser.me_state;
              this.toUserInfo.recState = toUser.rec_state;
              if (this.toUserRole == 1 && ((this.toUserInfo.meState != 1 && this.toUserInfo.meState != 12) || this
                .toUserInfo.recState > 10)) {
                this.notLookJob = true;
                this.$message.error('该人才暂时不找工作');
              } else {
                this.notLookJob = false;
              }
            } else {
              this.notLookJob = false;
            }
          } else {
            this.$$message.error(m.errmsg);
          }
        });
      },
      changeJob() {
        this.jobTransEnable = false;
        this.selectJobShow = true;
      },
      onCloseSelectJob() {
        this.jobTransEnable = false;
        this.$nextTick(function () {
          this.selectJobShow = false;
        });
      },
      onSelectJob(jobId) {
        if (jobId === this.jobId) {
          this.jobTransEnable = false;
          this.selectJobShow = false;
          return;
        }
        // var oldJobId = this.jobId;
        this.jobId = jobId;
        this.getJobInfo();
        // if (oldJobId <= 0) {
        //   this.sendHelloMessage();
        // }
        var msgObj = {
          chat_id: 0,
          type: 3, //更换职位
          content: '更换了沟通的职位',
          from_user_id: this.fromUserId,
          from_user_role: this.fromUserRole,
          to_user_id: this.toUserId,
          to_user_role: this.toUserRole,
          job_id: jobId,
          job: {}
        };
        getJobSimpleInfo({
          job_id: this.jobId,
        }).then(m => {
          if (m.errcode == 0) {
            msgObj.job = m.data;
          }
        });
        let strMsg = {
          'type': 2, //文本类型消息
          'data': msgObj
        };
        let msg = JSON.stringify(strMsg);
        let that = this;
        send(msg, function () {
          that.onSendError(strMsg);
        });
        this.messages.push(msgObj);
        this.$nextTick(() => {
          this.scrollEnd();
        });
        this.selectJobShow = false;
      },
      getJobInfo() {
        if (this.toUserRole !== 1) {
          return;
        }
        if (!this.jobId || this.jobId <= 0) {
          getJobId({
            to_user_id: this.toUserId,
            to_user_role: this.toUserRole
          }).then(m => {
            if (m.errcode === 0) {
              this.jobId = m.data;
              if (this.jobId <= 0) {
                this.selectJobShow = true;
                this.jobTransEnable = true;
                this.$message('请选择一个职位');
                return;
              }
              getJobSimpleInfo({
                job_id: this.jobId,
              }).then(m => {
                if (m.errcode == 0) {
                  let job = m.data;
                  this.job = job;
                }
              });
            }
          });
        } else {
          getJobSimpleInfo({
            job_id: this.jobId,
          }).then(m => {
            if (m.errcode == 0) {
              let job = m.data;
              this.job = job;
            }
          });
        }
      },
      noConactAlert() {
        this.$message.warning('双方回复后才能使用');
      },
      inviteInterview() {
        var params = {
          to_user_id: this.toUserId,
          to_user_role: this.toUserRole
        };
        defaultInviteInfo(params).then(m => {
          if (m.errcode === 0) {
            var invite = m.data;
            if (invite) {
              this.inviteForm.inviteId = invite.inviteId;
              this.inviteForm.interviewId = invite.interviewId,
              this.inviteForm.interviewPhone = invite.interviewPhone,
              this.inviteForm.interviewPlace = invite.interviewPlace,
              this.inviteForm.interviewTime = this.$Shared.formatDateTime2(invite.interviewTime),
              this.inviteForm.meVote = invite.meVote,
              this.inviteForm.expired = invite.expired;
            }
            if (this.inviteForm.meVote === 2) { //如果人才拒绝邀约，面试时间不显示
              this.inviteForm.interviewTime = '';
            }
            this.inviteShow = true;
          } else {
            if (!this.jobId || this.jobId <= 0) {
              this.$message('请先选择一个职位');
              this.selectJobShow = true;
              return;
            }
            this.inviteShow = !this.inviteShow;
          }
        });
      },
      onConfirmInvite(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var msgObj = {
              chat_id: 0,
              type: 4,
              content: '发出面试邀请',
              from_user_id: this.fromUserId,
              from_user_role: this.fromUserRole,
              to_user_id: this.toUserId,
              to_user_role: this.toUserRole,
              job_id: this.jobId,
              interview_phone: this.inviteForm.interviewPhone,
              interview_place: this.inviteForm.interviewPlace,
              interview_time: this.$Shared.formatDateTime2(this.inviteForm.interviewTime)
            };
            let strMsg = {
              'type': 2, //文本类型消息
              'data': msgObj
            };
            let msg = JSON.stringify(strMsg);
            let that = this;
            send(msg, function () {
              that.onSendError(strMsg);
            });
            this.messages.push(msgObj);
            this.$message.success('面试邀请已发送');
            this.inviteShow = false;
            this.$nextTick(() => {
              this.scrollEnd();
            });
          } else {
            return false;
          }
        });
      },
      inviteAgain() {
        this.inviteForm.inviteId = 0;
        this.inviteForm.meVote = 0;
        this.inviteForm.interviewTime = '';
        this.$message('请重新选择面试时间发起面试邀请');
      },
      toInterview() {
        var interviewId = this.inviteForm.interviewId;
        this.$router.push({
          path: '/Interview',
          query: {
            interviewid: interviewId
          }
        });
      },
    }
  };
</script>

<style scoped>
  .title-box {
    line-height: 25px;
    background: #2e2e2e;
    padding: 20px 16px 14px 16px;
    border-bottom: 1px solid #666;
  }

  .chat-list {
    max-height: 619px;
    overflow: auto;
    border-bottom: 1px solid #3d3d3d;
  }

  .chat-list::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .chat-list::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #2e2e2e;
  }

  .chat-list::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px initial;
    box-shadow: inset 0 0 6px initial;
    background-color: #3d3d3d;
  }

  .chat-list .msg-item {
    position: relative;
    background: #3d3d3d;
    padding: 16px;
    border-bottom: 1px solid #3d3d3d;
    cursor: pointer;
  }

  .chat-list .active-msg-item {
    background: #2e2e2e;
    height: 59px;
  }

  .chat-list .active-msg-item .useravatar-cicle-m {
    width: 54px;
    height: 54px;
  }

  .chat-list .active-msg-item .who-name {
    font-size: 18px;
  }

  .chat-list .msg-item:hover {
    background: #2e2e2e;
  }

  .chat-list .msg-item .left {
    display: inline-block;
    height: 48px;
  }

  .leftMenu .chat-list .msg-item .right {
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 100%;
    font-weight: 400;
    font-size: 14px;
    position: relative;
  }

  .leftMenu .chat-list .msg-item .right .who-name {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    margin-bottom: 4px;
    display: inline-block;
    font-size: 14px;
  }

  .chat-list .msg-item .right .time {
    color: #999;
    font-size: 12px;
    line-height: 20px;
    text-align: right;
  }

  .chat-list .msg-item .right .last-msg {
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    line-height: 22px;
  }

  .chat-container {
    min-height: 600px;
    max-height: 100%;
    text-align: left;
  }

  .chat-container header {
    height: 64px;
    border-bottom: 1px solid #ebebeb;
    padding-left: 24px;
    line-height: 64px;
    color: #3d3d3d;
    font-size: 16px;
  }

  .chatHeader {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 20px;
  }

  .chat-tools-box {
    padding: 12px;
    font-size: 13px;
  }

  .chat-footer {
    margin: 4px;
    padding-right: 10px;
    text-align: right;
  }

  .bounce-enter-active {
    animation: bounce-in .5s;
  }

  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }

    50% {
      transform: scale(1.1);
    }

    100% {
      transform: scale(1);
    }
  }
</style>